"use client";

import { useEffect, useState } from "react";
import { useEspeces } from "../../hooks/api/especes";
import { PageHeader } from "../../ui/layout/page-header";
import { Card } from "../../components/ui/card";
import { EspeceList } from "../especes/espece-list";

export function BibliothequeEssencesBrowse() {
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(25);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [sortBy, setSortBy] = useState<string>("genre");
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");

  useEffect(() => {
    const timer: ReturnType<typeof setTimeout> = setTimeout(
      () => setDebouncedSearch(searchTerm),
      300
    );
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch, sortBy]);

  const { data, isLoading, error } = useEspeces({
    page,
    limit,
    search: debouncedSearch || undefined,
    sortBy,
    includeDeleted: false,
  });

  return (
    <div className="space-y-4">
      <PageHeader className="mb-0 space-y-1">
        <PageHeader.Title>Bibliothèque · Essences</PageHeader.Title>
        <PageHeader.Description>
          Liste consultable des essences disponibles.
        </PageHeader.Description>
      </PageHeader>
      <Card className="p-4">
        <EspeceList
          especes={data?.data ?? []}
          isLoading={isLoading}
          error={error}
          onView={() => { }}
          onEdit={() => { }}
          page={page}
          limit={limit}
          total={data?.meta.total ?? 0}
          sortBy={sortBy}
          onLimitChange={(nextLimit: number) => {
            setLimit(nextLimit);
            setPage(1);
          }}
          onSearchChange={(nextSearch: string) => setSearchTerm(nextSearch)}
          searchTerm={searchTerm}
          onPageChange={(nextPage: number) => setPage(nextPage)}
          handleSortChange={(nextSort: string) => setSortBy(nextSort)}
          showDeleted={false}
          onShowDeletedChange={() => { }}
          pageCount={data?.meta.totalPages ?? 0}
          mode="browse"
        />
      </Card>
    </div>
  );
}

